<template>
	<div>
		<div class="title-container">
			<div class="title">Activity Log Details</div>
			<div class="buttons">
				<router-link to="/activity-log" class="button"><div class="hover-title">Go Back</div><span class="fa fa-chevron-left"></span></router-link>
			</div>
		</div>
		<div class="input-container">
			<div class="input-box">
				<textarea-autosize v-model="details" readonly></textarea-autosize>
			</div>
		</div>
	</div>
</template>

<script>

export default {

	name: 'ActivityLogDetailPage',

	async asyncData({ app, route }) {
		const { data } = await app.$api.get(`/activity-log/${ route.params.id }/details`);

		return {
			log: data,
			details: JSON.stringify(JSON.parse(data.data), null, 4),
		};
	},

	data() {
		return {
			log: {},
			details: '',
		};
	},

};

</script>
